export default __webpack_public_path__ + "static/media/thoni_915_3.d64c4355.jpg";